import './App.css';
import { BrowserRouter} from 'react-router-dom';
import logo from './imgs/UFT-logo-white.png';
import Main from './main.js';

export default function App() {
  // Set Year for footer copyright
  let currentYear = new Date().getFullYear();

  
  return (
    <div className="App">
      <BrowserRouter>
        <Main></Main>
      </BrowserRouter>
      <footer className="footer">
        <img src={logo} alt="UFT" width="55" height="44" className="footer-logo"/>
        <p>Copyright &#169; 1999 – {currentYear} United Federation of Teachers</p>
      </footer>
    </div>
  );
}